
<template>
  <!--推送详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent narrow-row" :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>发送内容</h3>
      </div>
      <div class="card-body">
        <template v-for="(item, index) of pushContent">
        <a-form-item class="label-left" :key="index" :label="item.label" v-bind="{labelCol: { span: 2 }, wrapperCol: { span: 15 }}">
          <span v-if="item.key !== 'scope'" class="ant-form-text">{{item.value}}</span>
          <p v-else-if="item.key === 'scope'&& Array.isArray(item.value)" v-for="(part, i) of item.value" :key="i">{{part}}</p>
          <p v-else>{{item.value}}</p>
        </a-form-item>
        </template>
      </div>
    </div>

    <!--<div class="card">-->
      <!--<div class="card-head">-->
        <!--<h3>推送数据</h3>-->
      <!--</div>-->
      <!--<div class="card-body">-->
        <!--<a-row type="flex">-->
          <!--<a-col v-for="(item, index) of pushData" :key="index" :span="9">-->
            <!--<a-form-item class="form-item-push" :label="item.label" :class="[{'long': index<2}, {'short': index>1}]" :colon="index > 1">-->
              <!--<span class="ant-form-text">{{item.value}}</span>-->
            <!--</a-form-item>-->
          <!--</a-col>-->
        <!--</a-row>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
export default {
  name: 'pushDetail',
  data () {
    return {
      baseInfo: [
        {key: 'pushId', label: 'ID', value: ''},
        {key: 'pushOsDesc', label: '推送平台', value: ''},
        {key: 'pushAppDesc', label: '应用', value: ''},
        {key: 'statusDesc', label: '推送结果', value: ''},
        {key: 'sendTime', label: '推送时间', value: ''}
      ],
      pushContent: [
        {key: 'title', label: '标题', value: ''},
        {key: 'content', label: '内容', value: ''},
        {key: 'openTypeDesc', label: '后续动作', value: ''},
        {key: 'scope', label: '用户范围', value: ''}
      ],
      dynamicList: [
        {key: 'intentDesc', label: '指定页面', value: ''},
        {key: 'intentDesc', label: 'URL类型', value: ''},
        {key: 'url', label: 'URL', value: ''}
      ],
      pushData: [
        {key: '', label: 'iOS', value: ''},
        {key: '', label: 'Android', value: ''},
        {key: 'ios_total', label: '目标', value: ''},
        {key: 'android_total', label: '目标', value: ''},
        {key: 'ios_success', label: '送达', value: ''},
        {key: 'android_success', label: '送达', value: ''},
        {key: 'ios_click', label: '点击', value: ''},
        {key: 'android_click', label: '点击', value: ''}
      ]
    };
  },
  mounted () {
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/push/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        if (data.openType === 'open_link') {
          this.pushContent.splice(3, 0, ...this.dynamicList.slice(1));
        } else if (data.openType === 'open_app_page') {
          this.pushContent.splice(3, 0, this.dynamicList[0]);
        }

        this.loopSetVal(data, this.baseInfo);
        this.loopSetVal(data, this.pushContent);
        this.loopSetVal(data, this.pushData);
      });
    },
    loopSetVal (res, arr) {
      for (let item in res) {
        arr.forEach((el) => {
          if (el.key === item) {
            if (el.key === 'scope') {
              if (res.scopeType !== 0) {
                res[item] && (el.value = res[item].split(','));
              } else {
                el.value = res.scopeTypeDesc;
              }
            } else {
              el.value = res[item];
            }
          }
        });
      }
    }
  }
};
</script>
